
let token = localStorage.getItem('Authentication')
    ? JSON.parse(localStorage.getItem('Authentication')).access_token : '';
let refresh_token = localStorage.getItem('Authentication')
    ? JSON.parse(localStorage.getItem('Authentication')).refresh_token : '';
let token_type = localStorage.getItem('Authentication')
    ? JSON.parse(localStorage.getItem('Authentication')).token_type : '';

export const initialState = {
    token: '' || token,
    refreshToken: '' || refresh_token,
    tokenType: '' || token_type,
}

export const AuthReducer = (initialState, action) => {
    switch (action.type) {
        case "REQUEST_LOGIN":
            return {
                ...initialState
            };
        case "LOGIN_SUCCESS" || "REFRESH_TOKEN":
            return {
                ...initialState,
                token: action.payload.access_token,
                refreshToken: action.payload.refresh_token,
                tokenType: action.payload.token_type
            };
        case "LOGOUT":
            return {
                ...initialState,
                token: '',
                refreshToken: '',
                tokenType: ''
            };
        case "LOGIN_ERROR":
            return {
                ...initialState
            };
        default:
            throw new Error(`Unhandled action type: ${action.type}`)
    }
}